import { ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { errorInterceptor } from './shared/interceptors/error.interceptor';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),

    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
    ),

    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          darkModeSelector: 'html.dark-mode',
          cssLayer: false,
        },
      },
      // PrimeNG's default modal z-index (1100) sits below the app's fixed
      // topbar (candidate/panelist/corporate shells all use z-index: 3000
      // for .ip-topbar), so any dialog tall enough to extend above the
      // topbar's 64px height gets its top portion painted over and hidden
      // by the topbar -- looking like the dialog is cut off / "touching"
      // the navbar with no margin above it, even though it's actually
      // vertically centered underneath. Raising it above 3000 fixes that
      // for every dialog, not just the tall ones that happen to expose it.
      zIndex: {
        modal: 4000,
        overlay: 4000,
        menu: 4000,
        tooltip: 4000,
      },
    }),
    MessageService,
    ConfirmationService,

    // Tell Angular's anchor-scroll mechanism to leave room for the fixed
    // landing-page navbar (64px top bar + 46px role-tabs + 16px breathing room).
    {
      provide: APP_INITIALIZER,
      useFactory: (scroller: ViewportScroller) => () => scroller.setOffset([0, 126]),
      deps: [ViewportScroller],
      multi: true,
    },
  ],
};
